import Tracker from '@openreplay/tracker'
import { openReplayCSEKey, openReplaySecureMode } from '../config'

const tracker = new Tracker({
    projectKey: openReplayCSEKey,
    __DISABLE_SECURE_MODE: openReplaySecureMode
})


export { tracker }